/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import type { FC, PropsWithChildren } from 'react';
import { useEffect, useRef, useState } from 'react';
import { TwitterPicker } from 'react-color';
import { createPortal } from 'react-dom';

interface IPropsColorPicker {
  color: string;
  action: (hex: string) => void;
  width?: number;
}

const MouseTracker: FC<
  PropsWithChildren<{ offset: { x: number; y: number }; visible: boolean }>
> = ({ children, offset = { x: 0, y: 0 }, visible = true }) => {
  const element = useRef<HTMLDivElement>(null);

  const [xPosition, setXPosition] = useState(0);
  const [yPosition, setYPosition] = useState(0);

  const [savedXPosition, setSavedXPosition] = useState(-9999);
  const [savedYPosition, setSavedYPosition] = useState(-9999);

  useEffect(() => {
    function handler(ev: MouseEvent | TouchEvent) {
      if (element.current) {
        const rect = document.body.getBoundingClientRect();

        const e = (ev as TouchEvent).touches
          ? (ev as TouchEvent).touches[0]
          : ev;

        const x = (e as MouseEvent).clientX + offset.x - rect.left,
          y = (e as MouseEvent).clientY + offset.y - rect.top;
        setXPosition(x);
        setYPosition(y);
      }
    }
    document.addEventListener('mousemove', handler);
    document.addEventListener('touchmove', handler);
    return () => {
      document.removeEventListener('mousemove', handler);
    };
  }, [offset.x, offset.y]);

  useEffect(() => {
    if (visible) {
      setSavedXPosition(xPosition);
      setSavedYPosition(yPosition);
    } else {
      setSavedXPosition(-9999);
      setSavedYPosition(-9999);
    }

    return () => {
      setSavedXPosition(-9999);
      setSavedYPosition(-9999);
    };
  }, [visible]);

  return createPortal(
    <div
      style={{
        left: `${savedXPosition}px`,
        top: `${savedYPosition}px`,
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'all' : 'none',
        zIndex: 9999,
      }}
      className="absolute"
      ref={element}
    >
      {children}
    </div>,

    document.body
  );
};

export const ColorPicker = (props: IPropsColorPicker) => {
  const [show, setShow] = useState<boolean>(false);
  const [color, setColor] = useState<string>(props.color);

  const save = (newColor: { hex: string }) => {
    setColor(newColor.hex);
    props.action(newColor.hex);
  };

  return (
    <>
      <MouseTracker offset={{ x: -250, y: 25 }} visible={show}>
        {' '}
        <TwitterPicker
          triangle={'top-right'}
          onChangeComplete={save}
          color={color}
        />
      </MouseTracker>
      <div onClick={(e) => e.stopPropagation()}>
        <div
          onClick={() => setShow(true)}
          style={{
            aspectRatio: '1/1',
            backgroundColor: color,
            width: props?.width ?? 20,
            position: 'relative',
            borderRadius: '50%',
            pointerEvents: 'all',
            cursor: 'pointer',
          }}
        >
          {/* {show ? (
          <div
            style={{
              position: 'absolute',
              zIndex: '999',
              top: 30,
              right: -10,
            }}
          >
            <TwitterPicker
              triangle={'top-right'}
              onChangeComplete={save}
              color={color}
            />
          </div>
        ) : null} */}
        </div>
        {show &&
          createPortal(
            <div
              style={{
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
              }}
              onClick={() => setShow(false)}
            />,
            document.body
          )}
      </div>
    </>
  );
};

export default ColorPicker;
